import React from "react";

function CalibrationLayout({ taskDetails, taskSaveManagementDetails }) {
  const taskdetailsData = taskDetails || [];

  const evaldata = taskdetailsData.filter(
    (x) => x.elementid?.toLowerCase() === "evaluationform",
  );

  const agentdata = taskdetailsData.filter(
    (x) =>
      x.elementid?.toLowerCase() === "agentname" ||
      x.elementid?.toLowerCase() === "agentid",
  );

  const programdata = taskdetailsData.filter(
    (x) => x.elementid?.toLowerCase() === "programname",
  );

  const initiatordata = taskdetailsData.filter(
    (x) => x.elementid?.toLowerCase() === "initiatorname",
  );

  const evaluationFormName =
    evaldata
      .find((x) => x.label?.toLowerCase() === "evaluation form name")
      ?.labelValue?.trim() || "";

  const evaluationId =
    evaldata.find((x) => x.label?.toLowerCase() === "evaluation id")
      ?.labelValue || "";

  const evaluatedByName =
    evaldata
      .find((x) => x.label?.toLowerCase() === "evaluated by")
      ?.labelValue?.trim() || "";

  const agentName =
    agentdata
      .find((x) => x.label?.toLowerCase().includes("name"))
      ?.labelValue?.trim() || "";

  const programName =
    programdata
      .find((x) => x.label?.toLowerCase().includes("name"))
      ?.labelValue?.trim() || "";

  const initiatorName =
    initiatordata.find((x) => x.label?.toLowerCase().includes("name"))
      ?.labelValue || "";

  const calibrationId =
    taskSaveManagementDetails?.createdTask_CalibrationID || 0;

  return (
    <div className="d-flex flex-wrap space-between pt-15">
      {/* Calibration ID */}
      <div className="form-field">
        <label>Calibration ID</label>
        <input className="form-control" value={calibrationId} readOnly />
      </div>

      {taskDetails
        .filter((x) => x.showInCreatedTaskReview)
        .map((item, index) => {
          const labeltype = item.labeltype?.toLowerCase();
          const label = item.label?.toLowerCase();

          if (labeltype === "evaluation form") {
            if (label === "evaluation form") {
              return (
                <div key={index} className="form-field">
                  <label>{item.label}</label>
                  <input
                    className="form-control"
                    value={evaluationFormName}
                    readOnly
                  />
                </div>
              );
            }

            if (label === "evaluation id") {
              return (
                <div key={index} className="form-field">
                  <label>{item.label}</label>
                  <input
                    className="form-control"
                    value={evaluationId}
                    readOnly
                  />
                </div>
              );
            }

            if (label === "evaluated by") {
              return (
                <div key={index} className="form-field">
                  <label>{item.label}</label>
                  <input
                    className="form-control"
                    value={evaluatedByName}
                    readOnly
                  />
                </div>
              );
            }
          }

          if (labeltype === "program name" && label.includes("name")) {
            return (
              <div key={index} className="form-field">
                <label>{item.label}</label>
                <input className="form-control" value={programName} readOnly />
              </div>
            );
          }

          if (labeltype?.includes("agent") && label.includes("name")) {
            return (
              <div key={index} className="form-field">
                <label>User Evaluated</label>
                <input className="form-control" value={agentName} readOnly />
              </div>
            );
          }

          if (labeltype === "initiator name" && label.includes("name")) {
            return (
              <div key={index} className="form-field">
                <label>Initiator</label>
                <input
                  className="form-control"
                  value={initiatorName}
                  readOnly
                />
              </div>
            );
          }

          if (labeltype === "interaction id") {
            return (
              <div key={index} className="form-field">
                <label>{item.label}</label>
                <input
                  className="form-control"
                  value={item.labelValue || ""}
                  readOnly
                />
              </div>
            );
          }

          if (labeltype === "due date") {
            return (
              <div key={index} className="form-field">
                <label>Due Date</label>
                <input
                  className="form-control"
                  value={item.labelValue || ""}
                  readOnly
                />
              </div>
            );
          }

          if (labeltype === "comments") {
            return (
              <div key={index} className="form-field w-100">
                <label>Initiator Comments</label>
                <textarea
                  className="form-control"
                  value={item.labelValue || ""}
                  readOnly
                />
              </div>
            );
          }

          return null;
        })}
    </div>
  );
}

export default CalibrationLayout;
